module.exports = __webpack_public_path__ + "media/images/application/template/spacer-d21dc5682879c1571e06277b5028e24e.gif";